<template>
    <div>
        <div>
            <h5>Forgot your password?</h5>
            <p class="text-muted my-3">
                Enter your email below and we will send you instructions on how to change your password.
            </p>
        </div>
        <form class="py-5 my-md-5" @submit.prevent="sendResetPasswordEmail">
            <div class="form-group">
                <input type="email" placeholder="Email" v-model="email" class="form-control" required>
            </div>
            <button type="submit" class="btn btn-primary btn-block">Send</button>
        </form>
        <div class="pt-1">
            Return to
            <router-link to="/login" tag="a" class="text-primary font-weight-bold">Sign in</router-link>
        </div>
    </div>    
</template>

<script >
export default {
    name: 'ForgotPassword',
    data() {
        return {
            email: ''
        }
    },
    
    methods: {
        sendResetPasswordEmail() {
            const path = process.env.API_LOCATION + `/send_reset_password`;
            this.$http.post(path, {email: this.email})
            .then(() => {
                this.$router.push("/login/")
                this.$emit("success", "Email successfully send! Check your inbox.");
            })
            .catch(error => {
                this.$emit("error", "Unable to send reset password email.")
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/ForgotPassword.vue